'use client';
import React from 'react';
import { useIntersectionObserver } from '@repo/ui/src/hooks/useIntersectionObserver';
import { classNames } from '@repo/ui/src/utils/classNames';
import Container from '@repo/ui/src/primitives/Container';
import { OrderDetailProps } from '@views/OrderDetail/OrderDetailContent';
import styles from './ShipmentStatus.module.css';

export type ShipmentStatusText = Pick<OrderDetailProps, 'statuses'>;

export interface ShipmentStatusProps extends ShipmentStatusText {
  currentStatus: ShipmentStatuses;
}

export enum ShipmentStatuses {
  digital = -1,
  processing = 0,
  preparing = 1,
  shipped = 2,
  delivered = 3,
}

const ShipmentStatus = ({ statuses, currentStatus }: ShipmentStatusProps) => {
  const ref = React.useRef<HTMLUListElement>(null);
  const entry = useIntersectionObserver(ref, { threshold: 1 });

  return (
    <Container maxWidth="4xl" className="hidden sm:block w-full pb-10">
      <ul
        className={classNames(
          "relative grid grid-flow-col justify-between list-none p-0 z-10 after:content-['_'] after:block  after:h-px after:absolute after:w-11/12 after:left-4 after:top-[28px] after:-z-10",
          styles.shippingStatusContainer,
          entry?.isIntersecting && styles.active,
        )}
        ref={ref}
      >
        {statuses.map(({ title }, index) => (
          <li key={title} className="grid justify-items-center relative">
            <span
              className={classNames(
                'tra-text-web-heading-7 grid place-content-center rounded-full text-white w-14 h-14',
                currentStatus >= index ? styles.shippingStatus : 'bg-warm-400',
                entry?.isIntersecting && styles.active,
              )}
              aria-label={title}
            >
              {index + 1}
            </span>
            <p className="tra-text-web-body-l font-bold absolute -bottom-[2em] left-1/2 -translate-x-1/2 whitespace-nowrap">
              {title}
            </p>
          </li>
        ))}
      </ul>
    </Container>
  );
};

export default ShipmentStatus;
